module.exports = __webpack_public_path__ + "img/AdobeStock_167409022.78a42dc6.gif";